import React from 'react';
// TODO: Import @material-ui from design-system folder
/* eslint-disable restrict-imports/restrict-imports */
import { Typography, makeStyles, Paper } from '@material-ui/core';
import { TextCollectionToast } from './reducer';

interface ReviewFooterProps {
  toast: TextCollectionToast;
}

export default function ReviewFooter(props: ReviewFooterProps) {
  const styles = useReviewFooterStyles();
  const cmd = getCommandKey();
  return (
    <Paper elevation={2} square classes={{ root: styles.footer }}>
      <div className={styles.section}>
        <Typography classes={{ root: styles.heading }}>Navigate</Typography>
        <div className={styles.combo}>
          <kbd className={styles.key}>&larr;</kbd>
          <kbd className={styles.key}>&uarr;</kbd>
          <kbd className={styles.key}>&rarr;</kbd>
          <kbd className={styles.key}>&darr;</kbd>
        </div>
      </div>
      <div className={styles.section}>
        <Typography classes={{ root: styles.heading }}>Copy</Typography>
        <div className={styles.combo}>
          <kbd className={styles.key}>{cmd}</kbd>
          <span className={styles.plus}>+</span>
          <kbd className={styles.key}>C</kbd>
        </div>
      </div>
      <div className={styles.section}>
        <Typography classes={{ root: styles.heading }}>Cut</Typography>
        <div className={styles.combo}>
          <kbd className={styles.key}>{cmd}</kbd>
          <span className={styles.plus}>+</span>
          <kbd className={styles.key}>X</kbd>
        </div>
      </div>
      <div className={styles.section}>
        <Typography classes={{ root: styles.heading }}>Paste</Typography>
        <div className={styles.combo}>
          <kbd className={styles.key}>{cmd}</kbd>
          <span className={styles.plus}>+</span>
          <kbd className={styles.key}>V</kbd>
        </div>
      </div>
      <div className={styles.section}>
        <Typography classes={{ root: styles.heading }}>Delete</Typography>
        <div className={styles.combo}>
          <kbd className={styles.key}>del</kbd>
        </div>
      </div>
      {props.toast.message === 'COPY' && (
        <div className={styles.toast}>{props.toast.title} copied!</div>
      )}
      {props.toast.message === 'PASTE-ERROR' && (
        <div className={styles.toast}>
          <span className={styles.invalid}>Invalid: </span>
          {props.toast.parent === '' && <span>{props.toast.child} does not paste anywhere</span>}
          {props.toast.parent !== '' && (
            <span>
              {props.toast.child} only pastes into {props.toast.parent}
            </span>
          )}
        </div>
      )}
    </Paper>
  );
}

const useReviewFooterStyles = makeStyles({
  footer: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingBottom: 4,
    position: 'relative',
  },
  toast: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
    fontSize: '13px',
    lineHeight: '20px',
    padding: '8px 16px',
  },
  invalid: {
    color: '#EA5F28',
    marginRight: 4,
  },
  section: {
    padding: 8,
    marginRight: 8,
    display: 'inline-block',
  },
  heading: {
    color: '#000000',
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '16px',
  },
  combo: {
    paddingTop: 4,
    color: '#808080',
    fontSize: '13px',
    height: 20,
  },
  key: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#F2F2F2',
    borderRadius: 4,
    paddingLeft: 4,
    paddingRight: 4,
    height: 20,
    minWidth: 20,
    '& + $key': {
      marginLeft: 4,
    },
  },
  plus: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 20,
    width: 12,
  },
});

function getCommandKey(): string {
  try {
    const isMac = navigator.platform.indexOf('Mac') > -1;
    if (isMac) {
      return '⌘';
    }
    const isWin = navigator.platform.indexOf('Win') > -1;
    if (isWin) {
      return '⊞';
    }
    return 'cmd';
  } catch (e) {
    return 'cmd';
  }
}
